var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{attrs:{"title":"订单详情","size":"50%","visible":_vm.dialogVisible,"direction":"rtl"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.dialogFormVisible}},[_c('div',{staticClass:"p-0-20"},[_c('Detail',{attrs:{"order_id":_vm.order_id,"is_drawer":1}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6a3c4de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/order/dialog/Detail.vue
// module id = null
// module chunks = 